export const TID = {
  navLogo: "nav-logo",
  navHome: "nav-link-home",
  navServices: "nav-link-services",
  navWork: "nav-link-work",
  navManifesto: "nav-link-manifesto",
  navContact: "nav-link-contact",
  navCta: "nav-cta-button",
  heroCta: "hero-cta-button",
  heroSecondaryCta: "hero-secondary-cta",
  contactForm: "contact-form",
  contactName: "contact-name-input",
  contactEmail: "contact-email-input",
  contactCompany: "contact-company-input",
  contactService: "contact-service-input",
  contactBudget: "contact-budget-input",
  contactMessage: "contact-message-input",
  contactSubmit: "contact-submit-button",
  contactSuccess: "contact-success-message",
  adminTable: "admin-inquiries-table",
  adminRefresh: "admin-refresh-button",
  adminStatTotal: "admin-stat-total",
  adminStatNew: "admin-stat-new",
  adminStatReviewed: "admin-stat-reviewed",
  adminStatArchived: "admin-stat-archived",
};
